<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.transferCoin') }}</b>
    </h3>
    <hr />
    <h3>
      <b>18.1 Transfer koin melalui Aplikasi Mobile (iOS/Android)</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih menu “Akun” di bagian kanan bawah melalui Aplikasi Mobile (iOS/Android)
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_67.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih Opsi “Koin Saya”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_68.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Anda akan masuk ke halaman koin saya, dimana akan ada informasi pembelian koin yang telah
        anda lakukan sebelumnya. Detail koin yang tersedia untuk di transfer akan ada tombol merah
        dengan keterangan "transfer"
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_69.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Klik tombol “Transfer”</li>
      <br />
      <li>
        Akan muncul halaman konfirmasi transfer koin. Silakan lengkapi kolom yang ada yakni:
        <ol>
          <li>Alamat email user agen calon penerima koin</li>
          <li>Jumlah koin yang ingin ditransfer (minimal 10 koin)</li>
          <li>Catatan transfer</li>
        </ol>
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_70.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Tekan Tombol “Transfer Koin”</li>
      <br />
      <li>
        Tekan Tombol “Ya”. Dan koin sudah berhasil di transfer.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_71.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Untuk melihat riwayat transfer koin yang telah anda lakukan, silahkan tekan tombol “Transfer
        Koin” di halaman muka aplikasi Agen Pilihan, atau
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_72.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih opsi "Transfer Koin" di halaman Akun
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_73.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Anda akan melihat halaman riwayat transfer koin.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_74.png"
            alt=""
          />
        </div>
      </li>
    </ul>
    <hr />
    <h3>
      <b>18.2 Transfer koin melalui Browser Laptop/PC</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih menu profil di sisi kanan atas dari halaman beranda Anda.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_40_4.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Pilih Opsi “Koin Saya”</li>
      <br />
      <li>
        Anda akan masuk ke halaman koin saya. Pada sub menu “Koin Saya” dimana akan ada informasi
        pembelian koin yang telah anda lakukan sebelumnya. Di sisi kanan tabel anda akan mendapatkan
        informasi terkait koin mana saja yang bisa anda Transfer ke Akun lain.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/transfer-coin-10.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Klik tombol “Transfer Koin”</li>
      <br />
      <li>
        Akan muncul halaman konfirmasi transfer koin. Silakan lengkapi kolom yang ada yakni:
        <ol>
          <li>Alamat email user agen calon penerima koin</li>
          <li>Jumlah koin yang ingin ditransfer (minimal 10 koin)</li>
          <li>Catatan transfer</li>
        </ol>
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/transfer-coin-11.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Tekan Tombol “Transfer Koin”
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/transfer-coin-12.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Tekan Tombol “Ya”. Dan koin sudah berhasil di transfer.</li>
      <br />
      <li>
        Untuk melihat riwayat transfer koin yang telah anda lakukan, pilih opsi sub menu “Transfer
        Koin” di halaman Akun.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/transfer-coin-13.jpg"
            alt=""
          />
        </div>
      </li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'TransferCoin',
};
</script>

<style></style>
